<template>
	<v-container class="mt-4 px-5" fluid>
		<span v-if="this.getCCNNUsuario.cargo == 'Jefe'">
			<TicketArea/>
		</span>

		<span v-if="this.getCCNNUsuario.cargo == 'Auxiliar'">
			<TicketAuxi/>
		</span>
	</v-container>
</template>
<script>
  import axios from 'axios';
  var moment = require('moment');
  moment.locale('es');
  
  import {mapGetters, mapActions} from 'vuex'
  import TicketArea from '@/views/tickets/operaciones/TicketArea'
  import TicketAuxi from '@/views/tickets/operaciones/TicketAuxi'

  export default {
  	components:{
  		TicketArea,
			TicketAuxi
  	},

    data: () => ({
     
    }),

    computed: {
      ...mapGetters('login',['getCCNNUsuario']),
    },

    created ( ){
      console.log( this.getCCNNUsuario )
    }

  }
</script>